module.exports = __webpack_public_path__ + "img/3.28_Russian_road_sign.ce13b060.svg";